import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import About from './components/About';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import Login from './components/Login';
import InitialData from './components/InitialData';
function App() {

  return (
    <>
    <AuthenticatedTemplate>
      <InitialData>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/id/:id" element={<Home />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Layout>
      </InitialData>
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <Login />
    </UnauthenticatedTemplate>
    </>
  );
}

export default App;
